import {Component} from "@angular/core";
import {Page} from "../../../orchestration/page";
import {PaymentModel} from "../../payment.model";
import {NavigationService} from "../../../orchestration/navigation.service";
import {LoadingService} from "../../../ui-elements/loading/loading.service";
import {WalletPaymentSubmissionFailure, WalletPaymentSubmissionResult, WalletProvider} from "../../payment";

/**
 * Used as a fallback to display an "active" wallet payment button in a popup page if the wallet payment provider
 * cannot submit directly via the "passive" button on the payment page or quick-pay panel.
 */
@Component({
    selector: "woa-wallet-payment-page",
    templateUrl: "./wallet-payment-page.component.html",
    providers: [{provide: Page, useExisting: WalletPaymentPageComponent}]
})
export class WalletPaymentPageComponent extends Page {
    WalletProvider = WalletProvider;

    constructor(public paymentModel: PaymentModel,
                private navigationService: NavigationService,
                private loadingService: LoadingService) {
        super();
    }

    onActive(): void {
        // Called during ordering flow when spinner is already active. Temporarily suspend.
        this.loadingService.dismissSpinner();
    }

    async paymentStarted(): Promise<void> {
        // Restart spinner - it will be dismissed when order placement completes.
        await this.loadingService.startSpinner(60000);
    }

    async paymentComplete(walletPaymentResponse: WalletPaymentSubmissionResult): Promise<any> {
        return this.navigationService.dismissPage(this, walletPaymentResponse);
    }

    async paymentFailed(walletSubmissionFailure: WalletPaymentSubmissionFailure): Promise<any> {
        return this.navigationService.dismissPage(this, walletSubmissionFailure, true);
    }

    async paymentCancelled(): Promise<any> {
        return this.navigationService.dismissPage(this);
    }
}



// WEBPACK FOOTER //
// ./src/app/payment/wallet-payment/wallet-payment-page/wallet-payment-page.component.ts